import { render, staticRenderFns } from "./ServiceTypeIndex.vue?vue&type=template&id=505fdb28"
import script from "./ServiceTypeIndex.vue?vue&type=script&lang=js"
export * from "./ServiceTypeIndex.vue?vue&type=script&lang=js"
import style0 from "./ServiceTypeIndex.vue?vue&type=style&index=0&id=505fdb28&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports